<div class="tabDs__cont">
  <div class="tabDs__bg tabDs__bg--{{type}} tabDs__bg--{{size}} tabDs__bg--{{type}}-{{size}}" [class.only-use-icon]="enabledIcons">
    <ng-container *ngFor="let tab of tabs; index as tabIndex; trackBy:trackById">
      <div
        class="tabDs__tab tabDs__tab--{{type}} tabDs__tab--{{type}}-{{size}}"
        [ngStyle]="{ width: tabWidth }"
        [class.only-use-icon]="enabledIcons"
        [class.selected]="isSelected(tabIndex)"
        (click)="selected(tab, tabIndex)">
        <ng-container *ngTemplateOutlet="(enabledIcons ? iconTemplate : textTemplate); context: { tab: tab, index: tabIndex }"></ng-container>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="useDivider">
    <div class="tabDs__divider" [ngStyle]="{ width: tabWidth, transform: 'translateX(' + dividerPosition + ')' }"></div>
  </ng-container>
</div>

<ng-template #iconTemplate let-tab="tab" let-index="index">
  <div class="tabDs__tab-icon">
    <app-ds-icon
      [icon]="tab?.Icon"
      [size]="16"
      [color]="iconFillColor(index)">
    </app-ds-icon>
  </div>
</ng-template>

<ng-template #textTemplate let-tab="tab" let-index="index">
  <div class="tabDs__tab-text tabDs__tab-text--{{size}}">
    <div class="tabDs__tab-text-title">
      <app-ds-typography
        [size]="fontSize"
        [fontFamily]="fontFamily.SemiBold"
        [text]="tab?.Title"
        [color]="fontColor(index)">
      </app-ds-typography>
      <ng-container *ngIf="useNotification(tab)">
        <app-ds-icon
          class="tabDs__tab-text-title-icon"
          [icon]="bullet"
          [size]="18"
          [color]="bulletColor">
        </app-ds-icon>
      </ng-container>
    </div>
    <ng-container *ngIf="useSubtitle(tab)">
      <app-ds-typography
        [size]="fontSize"
        [text]="tab?.Subtitle"
        [color]="fontColor(index)">
      </app-ds-typography>
    </ng-container>
  </div>
</ng-template>